import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export const dashboardHeatmapSteps: DriveStep[] = [
    {
        element: `#${ONBOARDING_IDS.HEATMAP_CHART}`,
        popover: {
            title: "Shot Chart",
            description:
                "Each dot represents a shot plotted on the rink. Hover over any point to see full details — shooter, result, speed, expected goals, and KPI indicators. " +
                "Coloured dots around each shot show the player's offensive, defensive, and team play ratings.",
            side: "top",
            align: "center",
        },
    },
    {
        element: `#${ONBOARDING_IDS.HEATMAP_RESULT_FILTERS}`,
        popover: {
            title: "Quick Result Filters",
            description:
                "Instantly filter the chart by shot outcome. Click <strong>Shots</strong> for the full picture, " +
                "<strong>Goals</strong> to isolate scoring plays, or <strong>Non-Goals</strong> to focus on missed opportunities.",
            side: "left",
            align: "center",
        },
    },
    {
        element: `#${ONBOARDING_IDS.HEATMAP_FILTERS}`,
        popover: {
            title: "Period & Player Filters",
            description:
                "Narrow the view by game period or individual player. " +
                "The legend buttons on the right let you toggle specific result types — Goals, Saved, Blocked, and Missed — on and off.",
            side: "bottom",
            align: "center",
        },
    },
];
